export const isTokenExpired = expiration => {
  // Get the current time in seconds
  const currentTime = Math.floor(Date.now() / 1000);

  // Compare the expiration time with the current time
  return expiration < currentTime;
};
